import { css } from '@emotion/core';
import { variables } from '@domain-group/fe-brary';
var colour = variables.colour;

/* eslint-disable import/prefer-default-export */
export var childCard = /*#__PURE__*/css("padding-bottom:8px;margin-bottom:8px;border-bottom:1px solid ", colour.neutral200, ";&:last-child{border:0;}");